import mailIcon from '../images/mail.svg';
import './Footer.css'

export default function Footer() {
    return (
        <div id = "footer" style = {{display: 'flex', flexWrap: 'wrap', gap: '100px', justifyContent: 'center', paddingBottom: '100px', paddingTop: '100px', left: '0', right: '0', marginRight: '0', backgroundColor: '#161616', position: 'absolute', width: '100vw'}}>
            <div id = "footer-one" style = {{gap: '2px'}}> {/* Left side of footer */}
                <h1 style = {{ fontSize: '24px'}}>KC SOCIAL NEST</h1>
                <div style = {{display: 'flex'}}>
                    <img src = {mailIcon}></img>
                    <p style = {{marginLeft: '6px'}}>admin@kcsocialnest.com</p>
                </div>
                <p style = {{color: 'var(--grey)'}}>Powered by <a style = {{color: 'var(--grey)'}}href = "">Nissen Creative</a></p>
            </div>
            <div id = "footer-two" style = {{display: 'flex', flexWrap: 'wrap', gap: '100px', maxWidth: '95vw'}}> {/* Right side of footer */}
                <div style = {{width: 'min-content', display: 'flex', 'flex-direction': 'column', gap: '2px'}}>
                    <h1 style = {{fontSize: '20px'}}>Index</h1>
                    <a className = "footer-link" href = "/">Home</a>
                    <a className = "footer-link" href = "/about">About</a>
                    <a className = "footer-link" href = "/chat">Chat</a>
                    <a className = "footer-link" href = "/#contact">Contact</a>
                </div>
                <div style = {{width: 'min-content', display: 'flex', 'flex-direction': 'column', gap: '2px'}}>
                    <h1 style = {{fontSize: '20px'}}>Legal</h1>
                    <a className = "footer-link" href = "/terms-of-service">Terms of Service</a>
                    <a className = "footer-link" href = "/privacy-policy">Privacy Policy</a>
                </div>
                <div style = {{width: 'min-content', display: 'flex', 'flex-direction': 'column', gap: '2px'}}>
                    <h1 style = {{fontSize: '20px'}}>Clinics</h1>
                    <a className = "footer-link" href = "/register">Register a clinic</a>
                </div>
            </div>
        </div>
    )
}